import { Button } from "antd";
import { useSelector } from "react-redux";
import "./plan-overview.scss";
import { useHistory } from "react-router-dom";
import paymentsService from "../../../../../common/services/payments-service";

const PlanOverview = () => {
  const user = useSelector((state) => state.profile.user);
  let history = useHistory();

  const handleClick = () => {
    paymentsService
      .createSession({
        priceId: "price_1KQjcODD6XrDuzW97XZ2tsoC",
        user: user,
        successUrl: "https://mobile-vizcom.web.app/s2r",
        cancelUrl: "https://mobile-vizcom.web.app/s2r",
      })
      .then((session) => {
        // reroute to checkout
        window.location.href = session.data.url;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleManageSubscription = async () => {
    const session = await paymentsService.getcheckoutSession({
      stripe_customer_id: user.stripe_customer_id,
    });
    if (session.status === 200) {
      const portal = await paymentsService.createPortalSession({
        customerId: user.stripe_customer_id,
        returnUrl: "https://www.vizcom.co/settings",
      });
      if (portal.status === 200) {
        window.location.href = portal.data.url;
      }
    }
  };

  return (
    <div className="plan-overview-container">
      <h5 className="plan-header">Plan Overview</h5>
      <div className="plan-overview-membership-container">
        <p className="plan-info-text">
          {user?.membership.charAt(0).toUpperCase() + user?.membership.slice(1)}{" "}
          {user?.membership === "pioneer" ? "⭐" : ""}
        </p>
        {user?.membership === "free" ? (
          <div>
            <Button
              type="primary"
              style={{
                borderRadius: "0.2rem",
                backgroundColor: "#447ce9",
                border: "none",
                fontWeight: 600,
                fontSize: "12px",
              }}
              onClick={() => {
                handleClick();
              }}
            >
              Upgrade
            </Button>{" "}
          </div>
        ) : (
          user?.stripe_customer_id && (
            <div>
              <Button
                type="primary"
                style={{
                  borderRadius: "0.2rem",
                  backgroundColor: "#447ce9",
                  border: "none",
                  fontWeight: 600,
                  fontSize: "12px",
                }}
                onClick={() => {
                  handleManageSubscription();
                }}
              >
                Manage
              </Button>{" "}
            </div>
          )
        )}
      </div>
    </div>
  );
};
export default PlanOverview;
